"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
const formFields_1 = require("../models/formFields");
// import {organisation} from "./parametres";
class Login extends webix_jet_1.JetView {
    config() {
        const motdepasseField2 = { view: "text", type: "password", label: (0, globals_1._)("Mot de passe"), name: "motdepasse2",
            id: "motdepasseField2",
            attributes: { maxlength: 24 },
            labelWidth: 130, labelAlign: "right", bottomPadding: 45,
            bottomLabel: (0, globals_1._)("Le mot de passe doit comprendre au moins 8 caractères, une majuscule, une minuscule et un chiffre")
        };
        const nbtField = { view: "template", template: "", height: 50, borderless: true, id: "nbtField" };
        var form = {
            id: "loginForm", view: "form", scroll: false, width: 400, align: "center",
            localId: "login:form",
            elements: [
                { view: "template", template: "Saisie d'un nouveau mot de passe", height: 30, borderless: true },
                formFields_1.emailField,
                formFields_1.motdepasseField,
                motdepasseField2,
                { view: "label" },
                {
                    rows: [
                        { margin: 5,
                            cols: [
                                { view: "button", value: (0, globals_1._)("Valider"), css: "webix_primary", id: "connexionButton",
                                    click: () => this.valider()
                                },
                                { view: "button", value: (0, globals_1._)("Annuler"),
                                    click: () => this.annuler()
                                }
                            ] }
                    ]
                }
            ]
        };
        return {
            view: "window",
            id: "loginWindow",
            // @ts-ignore
            head: organisation,
            // modal:true,
            position: "center",
            body: form
        };
    }
    valider() {
        const form = this.$$("login:form");
        let me = this;
        // @ts-ignore
        const data = form.getValues();
        // @ts-ignore
        webix.ajax().post(globals_1.phpPath + "login.php?option=valideMotDePasse", {
            identifiant: data.identifiant,
            motdepasse: data.motdepasse,
            motdepasse2: data.motdepasse2
        }).then(function (result) {
            if (result.json().success == true) {
                window.location.href = "#!/login";
                return;
            }
            else {
                me.noaccess(result.json().message);
            }
        });
    }
    noaccess(message) {
        webix.alert({
            text: (message),
            type: "error",
            expire: 5000
        });
        this.count = this.count - 1;
        $$("buttonDemande").enable();
        if (this.count == 0) {
            $$("connexionButton").disable();
        }
        let nbtField = $$("nbtField");
        nbtField.setHTML(this.count + " tentatives restantes");
    }
    annuler() {
        window.location.href = "http://first.alnitac.com";
    }
    init(view) {
        this.count = 5;
        $$("loginWindow").show();
        view.$view.querySelector("input").focus();
    }
}
exports.default = Login;
